module.exports = __webpack_public_path__ + "static/media/header-text.738c7810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-text.jpg
// module id = 319
// module chunks = 0